import React from 'react'
import styled from 'styled-components'
import { SearchLeadsFirst } from '../../Components/Leads/Search leads/SearchLeadsFirst'
import { colors } from '../../Shared/colors'

export const SearchLeadsComponent = () => {
  return (
    <Main>
      <SearchLeadsFirst/>
      {/* <SearchLeadsDataTable/> */}
    </Main>
  )
}

const Main = styled.div`
  background: linear-gradient(135deg, ${colors.lightWhite} 0%, ${colors.inputWhite} 100%);
  min-height: 100vh;
  padding: 1rem 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  
  &::before {
    content: '';
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: 
      radial-gradient(circle at 20% 80%, rgba(36, 147, 147, 0.05) 0%, transparent 50%),
      radial-gradient(circle at 80% 20%, rgba(0, 114, 253, 0.05) 0%, transparent 50%);
    pointer-events: none;
    z-index: 0;
  }
  
  > * {
    position: relative;
    z-index: 1;
  }
`

